import {NotificationType} from "../../../Scalesoft.Shared.FrontEnd/Scripts/Enums/NotificationType";
import GuiCommonShared from "../../../Scalesoft.Shared.FrontEnd/Scripts/GuiCommonShared";
import Duration from "../../../Scalesoft.Shared.FrontEnd/Scripts/JQueryConstants";
import NotificationConfiguration from "../../../Scalesoft.Shared.FrontEnd/Scripts/NotificationConfiguration";
import ApiClient from "./ApiClient";

declare const basePath: string;

export default class NotificationSidebar {
    private readonly apiClient: ApiClient;
    private readonly guiCommon: GuiCommonShared;
    private readonly mLocalization: Localization;
    protected readonly jq: JQueryStatic;

    private notificationDetail: JQuery;
    private notificationToggler: JQuery;
    private notificationTogglerCollapsed: JQuery;
    protected sidebar: JQuery;
    private heading: JQuery;
    protected collapseNotificationDetailsBtn: JQuery;
    private clearNotificationBtn: JQuery;
    protected clearAllNotificationsBtn: JQuery;
    private badge: JQuery;
    private toast: JQuery;

    private readonly right: number;

    private readonly notificationTogglerEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly notificationTogglerCollapsedEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly documentEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly sidebarEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly notificationHeadingEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly collapseNotificationDetailsBtnEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly clearNotificationBtnEventHandler: (event: JQuery.ClickEvent) => void;
    private readonly clearAllNotificationsBtnEventHandler: (event: JQuery.ClickEvent) => void;

    constructor(
        localization: Localization,
        jQuery: JQueryStatic,
    ) {
        this.notificationDetail = jQuery([]);
        this.notificationToggler = jQuery([]);
        this.notificationTogglerCollapsed = jQuery([]);
        this.sidebar = jQuery([]);
        this.heading = jQuery([]);
        this.collapseNotificationDetailsBtn = jQuery([]);
        this.clearNotificationBtn = jQuery([]);
        this.clearAllNotificationsBtn = jQuery([]);
        this.badge = jQuery([]);
        this.toast = jQuery([]);

        this.jq = jQuery;
        this.mLocalization = localization;
        this.apiClient = new ApiClient(basePath, this.jq);
        this.guiCommon = new GuiCommonShared(this.mLocalization, this.jq);

        this.assignTargetElements();
        this.right = (1 - (this.sidebar.width() ?? 0)) - 40; // TODO remove magic string

        this.notificationTogglerEventHandler = (e) => {
            e.stopPropagation();
            if (this.sidebar.is(":visible")) {
                this.jq(document.documentElement).trigger("click");
            } else {
                this.sidebar.animate({right: 0} as JQuery.PlainObject).show();

                this.markNotificationsAsRead();
            }
        };

        this.notificationTogglerCollapsedEventHandler = (e) => {
            e.stopPropagation();
            if (this.sidebar.is(":visible")) {
                this.jq(document.documentElement).trigger("click");
            } else {
                this.sidebar.animate({right: 0} as JQuery.PlainObject).show();

                this.markNotificationsAsRead();
            }
        };

        this.documentEventHandler = () => {
            if (this.sidebar.is(":visible")) {
                this.sidebar.animate({right: this.right} as JQuery.PlainObject,
                    () => {
                        this.sidebar.hide();
                    });
            }
        };

        this.sidebarEventHandler = (e) => {
            e.stopPropagation();
        };

        this.notificationHeadingEventHandler = (event: JQuery.ClickEvent) => {
            const targetEl = this.jq(event.target as HTMLElement);
            if (!targetEl.is("button, span")) {
                targetEl.parents(".notification-item").find(".notification-detail").slideToggle(Duration.Default);

            }
        };

        this.collapseNotificationDetailsBtnEventHandler = (event) => {
            const clickedButtonJq = this.jq(event.currentTarget);
            const buttonIcon = clickedButtonJq.children();
            if (this.notificationDetail.is(":visible")) {
                this.notificationDetail.slideUp(Duration.Default);
                buttonIcon
                    .removeClass("fa-caret-square-up")
                    .addClass("fa-caret-square-down");
            } else {
                this.notificationDetail.slideDown(Duration.Default);
                buttonIcon
                    .removeClass("fa-caret-square-down")
                    .addClass("fa-caret-square-up");
            }
        };

        this.clearNotificationBtnEventHandler = (event: JQuery.ClickEvent) => {
            const targetEl = event.target as HTMLElement;
            const notificationItem = this.jq(targetEl).closest(".notification-item");
            const notificationId = this.getNotificationId(notificationItem);

            this.apiClient.dismissNotification(notificationId).done(() => {
                // notificationItem.tooltip("dispose");
                this.removeNotification(notificationItem.get(0));

            }).fail(() => {
                const notificationConfig = new NotificationConfiguration({
                    notificationType: NotificationType.Danger,
                    // tslint:disable-next-line:deprecation
                    messages: [this.mLocalization.translate("clear-failed", "notification").value],
                    container: this.jq(".notification-selector"),
                });
                this.guiCommon.showNotification(notificationConfig);
            });
        };

        this.clearAllNotificationsBtnEventHandler = () => {
            const notificationIds = this.getAllNotificationIds();
            this.apiClient.dismissAllNotifications(notificationIds).done(() => {
                const notificationItems = this.jq(".notification-item");
                notificationItems.each((index, element) => {
                    this.removeNotification(element);
                });
            }).fail(() => {
                const notificationConfig = new NotificationConfiguration({
                    notificationType: NotificationType.Danger,
                    // tslint:disable-next-line:deprecation
                    messages: [this.mLocalization.translate("clear-failed", "notification").value],
                    container: this.jq(".notification-selector"),
                });
                this.guiCommon.showNotification(notificationConfig);
            });
        };
    }

    private assignTargetElements(): void {
        this.notificationDetail = this.jq(".notification-detail");
        this.notificationToggler = this.jq("#notification-toggler");
        this.notificationTogglerCollapsed = this.jq("#notification-toggler-collapsed");
        this.sidebar = this.jq(".notification-sidebar");
        this.heading = this.jq(".notification-heading");
        this.collapseNotificationDetailsBtn = this.jq(".collapse-notification-details-btn");
        this.clearNotificationBtn = this.jq(".clear-notification");
        this.clearAllNotificationsBtn = this.jq(".clear-all-notifications");
        this.badge = this.jq(".notification-toggler-btn .badge");
        this.toast = this.jq(".notification-sidebar .toast");
    }

    protected initToasts(): void {
        this.toast.toast().toast("show");
    }

    protected hideToasts(): void {
        this.toast.toast().toast("hide");
    }

    public init(): void {
        if (!this.sidebar.hasClass("displayed")) {
            this.sidebar.css("right", this.right);
        } else {
            this.sidebar.show();
            this.markNotificationsAsRead();
        }

        if (this.badge.text() === "0") {
            this.badge.hide();
        }

        this.initToasts();

        this.notificationToggler.on("click", this.notificationTogglerEventHandler);
        this.notificationTogglerCollapsed.on("click", this.notificationTogglerCollapsedEventHandler);
        this.jq(document).on("click", this.documentEventHandler);
        this.sidebar.on("click", this.sidebarEventHandler);
        this.heading.on("click", this.notificationHeadingEventHandler);
        this.collapseNotificationDetailsBtn.on("click", this.collapseNotificationDetailsBtnEventHandler);
        this.clearNotificationBtn.on("click", this.clearNotificationBtnEventHandler);
        this.clearAllNotificationsBtn.on("click", this.clearAllNotificationsBtnEventHandler);
        this.clearAllNotificationsBtn.add(this.collapseNotificationDetailsBtn).add(this.clearNotificationBtn);

        // .tooltip({ // Tooltip disabled because of conflicts between jQuery-UI and Bootstrap and no-conflict configuration
        //    trigger: "hover",
        //    placement: "left",
        //    container: ".notification-sidebar"
        // });
        // this.jq("body").tooltip({ selector: ".has-tooltip" });
    }

    public reinit(): void {
        this.notificationToggler.off("click", this.notificationTogglerEventHandler);
        this.notificationTogglerCollapsed.off("click", this.notificationTogglerCollapsedEventHandler);
        this.jq(document).off("click", this.documentEventHandler);
        this.sidebar.off("click", this.sidebarEventHandler);
        this.heading.off("click", this.notificationHeadingEventHandler);
        this.collapseNotificationDetailsBtn.off("click", this.collapseNotificationDetailsBtnEventHandler);
        this.clearNotificationBtn.off("click", this.clearNotificationBtnEventHandler);
        this.clearAllNotificationsBtn.off("click", this.clearAllNotificationsBtnEventHandler);
        this.clearAllNotificationsBtn.add(this.collapseNotificationDetailsBtn).add(this.clearNotificationBtn);

        this.hideToasts();
        this.assignTargetElements();
        this.init();
    }

    public markNotificationsAsRead(): void {
        const notificationIds = this.getAllNotificationIds();
        this.apiClient.markAllNotificationsAsRead(notificationIds);
        this.badge.hide();
    }

    public noNewNotificationsMsg(): HTMLElement {
        const alertSettings = new NotificationConfiguration({
            // tslint:disable-next-line:deprecation
            messages: [this.mLocalization.translate("no-notifications-msg", "notification").value],
            notificationType: NotificationType.Info,
        });
        return this.guiCommon.showNotification(alertSettings);
    }

    public destroyNotification(container?: JQuery): void {
        const notificationContainer = container ? container : this.jq(".notification-selector");
        const alertBox = notificationContainer.find(".alert");
        alertBox.fadeOut(Duration.Default,
            () => {
                alertBox.remove();
            });
    }

    private getNotificationId(notificationItem: JQuery): number {
        const id = notificationItem.data("notification-id");
        return Number(id);
    }

    private getAllNotificationIds(): number[] {
        const resultList = new Array<number>();
        this.jq(".notification-item").each((index, element) => {
            const notificationId = this.getNotificationId(this.jq(element));
            resultList.push(notificationId);
        });
        return resultList;
    }

    protected removeNotification(notificationsToRemove: HTMLElement): void {
        const notificationsToRemoveJq = this.jq(notificationsToRemove);
        notificationsToRemoveJq.toast("hide");
        notificationsToRemoveJq.on("hidden.bs.toast",
            () => {
                notificationsToRemoveJq.remove();
                const notificationItems = this.jq(".notification-item");
                if (notificationItems.length === 0) {
                    this.sidebar.append(this.noNewNotificationsMsg());
                }

                if (notificationItems.filter(".high-priority-notification").length === 0) {
                    this.sidebar.find(".important-container").remove();
                }

                this.collapseNotificationDetailsBtn.prop("disabled", () => {
                    return notificationItems.length === 0;
                });

                this.clearAllNotificationsBtn.prop("disabled", () => {
                    return notificationItems.length === 0;
                });
            });
    }
}
